import React, { Fragment } from "react";
import "./Navbar.css";

const Intro = () => {
  return (
    <Fragment>
      <div className="introPage">
        <div className="introSection">
          <p style={{ color: "rgb(109, 243, 200)" }}>
            Hello visitor, my name is
          </p>
          <div style={{ fontSize: "3rem" }}>Gaurav Sachar</div>
          <div style={{ color: "#BBBBBB", fontSize: "3rem" }}>
            I build things for the <span className="webPoint">web</span>
          </div>
          <p className="basics">
            I'm a web developer based in New Delhi specializing in building
            exceptional, high-quality websites and web applications.
          </p>
        </div>
      </div>
    </Fragment>
  );
};

export default Intro;
